const StopSaleModal = ({
  onConfirm,
  onClose,
  isModalOpen,
}: {
  onConfirm: () => void;
  onClose: () => void;
  isModalOpen: boolean;
}) => {
  return (
    <div className="w-full flex flex-col items-center">
      {/* 모달 추가 */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white rounded p-6">
            <div className="break-keep font-bold text-3xl p-8 text-center">
              고객이 이 메뉴를 <br />
              더이상 구매할 수 없습니다.
            </div>
            <div className="break-keep font-semibold text-xl pb-4 text-gray-400 text-center">
              현재 들어온 주문이 취소되진 않아요~
            </div>
            <div className="mt-4 flex justify-end">
              <button
                onClick={onClose}
                className="bg-gray-300 px-4 py-2 rounded"
              >
                취소
              </button>
              <button
                onClick={onConfirm}
                className="ml-2 bg-blue-500 text-white px-8 py-2 rounded"
              >
                확인
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StopSaleModal;
